import React, { useEffect, useState } from "react";
import { Button, Offcanvas, OverlayTrigger, Tooltip } from "react-bootstrap";

import { AddOutlined, ModeEditOutlined, DeleteForeverOutlined } from "@mui/icons-material";

import { CreateFaqs, getGeneralFaqs, UpdateFaqs } from "../../services/getGeneralFaqs";
import TinyMCE from "./tinyMCE";
import { toast } from "react-hot-toast";
import { idGenerator } from "../../helpers/idGenerator";
import useAudit from "../../hooks/useAudit";

const SidebarFaqs = ({ isEdit, faqsToEdit = null }) => {
  const [showEditSlide, setShowEditSlide] = useState(false);
  const { createAuditRequest } = useAudit();

  const handleCloseSlide = () => setShowEditSlide(false);
  const handleShowSlide = () => setShowEditSlide(!showEditSlide);

  const [categorySelected, setCategorySelected] = useState({});
  const [allFaqs, setAllFaqs] = useState([]);

  useEffect(() => {
    getGeneralFaqs().then((res) => {
      const getAllFaqs = res.data.allFaqs.filter((faq) => !faq.deleted);
      setAllFaqs(getAllFaqs);
    });
  }, []);

  useEffect(() => {
    setCategorySelected(faqsToEdit);
  }, [faqsToEdit]);

  const handleCategoryInput = ({ target }) => {
    setCategorySelected({
      ...categorySelected,
      [target.name]: target.value
    });
  };

  const handleDeleteFaq = (index) => {
    setCategorySelected({
      ...categorySelected,
      faq: categorySelected?.faq?.filter((faq, i) => faq?._id !== index)
    });
  };

  const handleFaqsInput = ({ target }) => {
    setCategorySelected({
      ...categorySelected,
      faq: categorySelected.faq?.map((faq, i) => {
        if (i === Number(target.id)) {
          return { ...faq, [target.name]: target.value };
        }
        return faq;
      })
    });
  };

  const handleAddFaqs = () => {
    isEdit
      ? setCategorySelected({
          ...categorySelected,
          faq: [...categorySelected?.faq, { question: "", answer: "", _id: idGenerator(12) }]
        })
      : setCategorySelected({
          ...categorySelected,
          faq: [
            ...(categorySelected?.faq ? categorySelected?.faq : ""),
            { question: "", answer: "", _id: idGenerator(12) }
          ]
        });
  };

  const user = JSON.parse(localStorage.getItem('Usuario'))?.UserLogin?.name

  const handleSubmit = async (e) => {
    e?.preventDefault();

    if (categorySelected.hasOwnProperty("_id")) {
      await createAuditRequest(
        {
          ...categorySelected,
          element: 3,
          creator: user
        },
        "EDIT"
      );
    } else {
      await createAuditRequest({
        ...categorySelected,
        element: 3,
        creator: user,
        _id: String(Math.ceil(Math.random() * (999999999999 - 100000000000) + 100000000000))
      });
    }
    setShowEditSlide(!showEditSlide);
  };

  return (
    <>
      <div className="pgi__sidebar-slides">
        <>
          <OverlayTrigger
            key="1"
            placement="top"
            overlay={<Tooltip id="1">{isEdit ? "Editar Slide" : "Nueva Categoría"}</Tooltip>}
          >
            <Button className="btn-form-pgi" variant="light" onClick={handleShowSlide}>
              {isEdit ? <ModeEditOutlined /> : <AddOutlined />}
            </Button>
          </OverlayTrigger>
        </>

        <Offcanvas
          show={showEditSlide}
          onHide={handleCloseSlide}
          className="basePgi__pgi  pgi__sidebar-container"
          placement="end"
          scroll="false"
          backdrop={false}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              Home / {isEdit ? <b>EDITAR CATEGORÍA </b> : <b>CREAR CATEGORÍA</b>}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <form className="basePgi__vista-edit-gral" onSubmit={handleSubmit}>
              <button type="submit" className="settings_button-pleno float-end botton-save-pgi">
                GUARDAR
              </button>
              <div className="input-group my-2" key={faqsToEdit?._id}>
                <small className="d-block w-100">Nombre de la categoría</small>
                <input
                  type="text"
                  className="form-control"
                  name={`category`}
                  placeholder="Ingrese el nombre"
                  id={faqsToEdit?._id}
                  defaultValue={faqsToEdit?.category}
                  onChange={handleCategoryInput}
                  maxLength={90}
                  minLength={2}
                />
              </div>
              <fieldset className="pgi__sidebar-container-items">
                <p className="basePgi__comments">
                  Desde aquí podrá cargar cada Faqs de la sección.
                </p>
                <div className="pgi__archivo pgi__install">
                  {categorySelected?.faq?.map((cat, i) => {
                    return (
                      <div className="mx-3">
                        <label htmlFor="title">{i + 1}</label>
                        <OverlayTrigger
                          key="1"
                          placement="top"
                          overlay={<Tooltip id="1">Eliminar</Tooltip>}
                        >
                          <Button onClick={() => handleDeleteFaq(cat?._id)}>
                            <DeleteForeverOutlined />
                          </Button>
                        </OverlayTrigger>
                        <div key={cat?._id}>
                          <div className="input-group my-2">
                            <small className="d-block w-100">Escriba su pregunta</small>
                            <input
                              type="text"
                              className="form-control"
                              name={`question`}
                              placeholder="Question"
                              id={i}
                              defaultValue={cat?.question}
                              onChange={handleFaqsInput}
                              maxLength={90}
                              minLength={2}
                            />
                          </div>
                          <TinyMCE
                            id={i}
                            values={cat.answer}
                            handleInputChange={handleFaqsInput}
                            name={"answer"}
                          />
                        </div>

                        <hr />
                      </div>
                    );
                  })}
                </div>
                <OverlayTrigger
                  key="1"
                  placement="top"
                  overlay={<Tooltip id="1">Nueva Pregunta</Tooltip>}
                >
                  <Button variant="light" className="btn-form-pgi allW" onClick={handleAddFaqs}>
                    <AddOutlined />
                  </Button>
                </OverlayTrigger>
              </fieldset>
            </form>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
};

export default SidebarFaqs;
